import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap'
import { getJockeyByDate, getRunnerOddsByMarketId, getWinnerInfo } from "../../../../service/backend-api-service"
const OddResultCell = (props) => {
    const [backOdd, setBackOdd] = useState("-")
    const [layOdd, setLayOdd] = useState("-")


    const fetchMetrics = (part) => {
        const a = async (part, index, array) => {
            if (part.runner && part.runner.selectionId && part.eventDetails && part.eventDetails.bfMarketId) {
                let odds = await getRunnerOddsByMarketId(part.eventDetails.bfMarketId, part.runner.selectionId)
                part.bestBackOdd = odds.bestBackOdd;
                part.bestLayOdd = odds.bestLayOdd;
                props.setSoccerLeaguesState(array)
            }
        }
        a(part);

    }

    
    useEffect(() => {
        const fetchData = async () => {
            let marketId = props.marketId;
            let selectionId = props.selectionId;
            let date = props.date;
            let odds = await getRunnerOddsByMarketId(marketId, selectionId, date)
            props.oddChangeCallback(marketId, selectionId, odds)
            setBackOdd(odds.bestBackOdd)
            setLayOdd(odds.bestLayOdd)
        }
        fetchData();
        const  interval = setInterval(() => {fetchData()}, 5000);
        return () => clearInterval(interval);

    }, [props.marketId, props.selectionId])

    let contentBody = null
    if ((backOdd === '-' && layOdd === '-') || (backOdd === null && layOdd === null)) {
    } else {
        contentBody =
            <ButtonGroup size="sm">
                <Button style={{backgroundColor: "#74BBEF"}} variant="outline-dark"><b>{backOdd}</b></Button>
                <Button style={{backgroundColor: "#F8AAB8"}} variant="outline-dark"><b>{layOdd}</b></Button>
            </ButtonGroup>
    }
    return (
        contentBody
    )
}

export default OddResultCell;